export default {
  methods: {
    openSecureModal( modaltype, contentkey ){
      this.$store.commit('SET_ACTIVE_MODAL', modaltype)
      this.$store.commit('SET_ACTIVE_MODAL_CONTENT', contentkey)
    },
    setCurrentProject( id ){
      this.$store.commit('SET_CURRENT_PROJECT', id)
    },
    addProject( projectName="" ){
      this.$spinnaApi.post('/private/project').then((response) => {
        this.$store.dispatch('GET_ALL_PROJECTS')
      }).catch((e) => { console.log(e) })
    },
    updateProject( id ){
      this.$spinnaApi.put('/private/project/' + id).then((response) => {
        this.$store.dispatch('GET_ALL_PROJECTS')
      }).catch((e) => { console.log(e) })
    },
    deleteProject( id ){
      this.$spinnaApi.delete('/private/project/' + id).then((response) => {
        this.$store.dispatch('GET_ALL_PROJECTS')
      }).catch((e) => { console.log(e) })
    },
    duplicatePhrase( id ){
      this.$spinnaApi.post('/private/phrase/duplicate/' + id).then((response) => {
        this.$store.dispatch('GET_ALL_PHRASES')
      }).catch((e) => { console.log(e) })
    },
    deletePhrase( id ){
      this.$spinnaApi.delete('/private/phrase/' + id).then((response) => {
        this.$store.dispatch('GET_ALL_PHRASES')
      }).catch((e) => { console.log(e) })
    },
  }
};
